module.exports = __webpack_public_path__ + "img/16d002-23.67d73c71.jpg";